import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import Select from 'components/Select/Select';
import Typography from 'components/Typography/Typography';
import { ArrowDownIcon, ArrowUpIcon } from 'icons';

type ActiveSortingStyledT = {
  $isActive: boolean;
};

type AscSortingStyledT = {
  $isActive: boolean;
  $isOrderAsc: boolean;
};

export const HeaderPriorityStyled = styled.th`
  width: 3%;
`;

export const HeaderROStyled = styled.th`
  width: 15%;
`;

export const HeaderLineNumberStyled = styled.th`
  width: 5%;
`;

export const HeaderAgeStyled = styled.th`
  width: 4.5%;
`;

export const HeaderStatusStyled = styled.th`
  width: 5.5%;
`;

export const HeaderAssigneeStyled = styled.th`
  width: 9%;
`;

export const HeaderTicketCheckBox = styled.th`
  width: 3.5%;
`;

export const HeaderCategoryStyled = styled.th`
  width: 9%;
`;

export const HeaderLastCommentStyled = styled.th`
  width: 11%;
  min-width: 200px;
`;

export const HeaderClaimStatusStyled = styled.th`
  width: 7.5%;
`;

export const HeaderAmountStyled = styled.th`
  width: 6.5%;
`;

export const HeaderAttachmentStyled = styled.th`
  width: 7%;
`;

export const HeaderApprovedStyled = styled.th`
  width: 6.5%;
`;

export const HeaderClaimAgeStyled = styled.th`
  width: 6.5%;
`;

export const ArrowUpIconStyled = styled(ArrowUpIcon)<AscSortingStyledT>`
  fill: ${({ $isActive, theme, $isOrderAsc }) =>
    $isActive && $isOrderAsc ? theme.colors.primary.variant1 : theme.colors.primary.variant7};
`;

export const ArrowDownIconStyled = styled(ArrowDownIcon)<AscSortingStyledT>`
  fill: ${({ $isActive, theme, $isOrderAsc }) =>
    $isActive && !$isOrderAsc ? theme.colors.primary.variant1 : theme.colors.primary.variant7};
`;

export const TextTitleStyled = styled(Typography)`
  color: ${({ theme }) => theme.colors.primary.variant7};
  ${({ theme }) => `
    ${theme.devices.desktop} {
      font-size: 0.75rem;
    }

    ${theme.devices.largeDesktop} {
      font-size: 0.875rem;
    }
  `}
`;

export const SortingIconsWrapStyled = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 6px;
  ${({ theme }) => `
    ${theme.devices.desktop} {
      margin-left: 3px;
    }

    ${theme.devices.largeDesktop} {
      margin-left: 6px;
    }
  `}
`;

export const TitleButtonStyled = styled(Button)<ActiveSortingStyledT>`
  align-items: center;
  padding: 0;
  ${TextTitleStyled} {
    color: ${({ $isActive: isActive, theme }) =>
      isActive ? theme.colors.primary.variant1 : theme.colors.primary.variant7};
  }
`;

export const SelectStyled = styled(Select)`
  width: 50%;
  margin-right: 10px;
  font-size: 0.875rem;
`;
